

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from '@/auth';

// Training data is fetched by useTrainingData() inside the authenticated tree - fetching it
// here would fire before MSAL initialises, 401, and bounce the page in a sign-in loop.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
